import React from "react";
import Header from "../components/Header";
import { DateTime } from "luxon";
import { useStateContext } from "../contexts/ContextProvider";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { GoDotFill } from "react-icons/go";
import { MessagesModal, NavigateBack } from "../components";
import { useNavigate } from "react-router-dom";

const Messages = () => {
  const {
    user,
    conversations,
    setConversationId,
    setMessageRecipientId,
    modal,
    handleModal,
  } = useStateContext();

  const navigate = useNavigate();

  const usersConversations = conversations.filter(
    (x) => x.senderId === user.id || x.recipientId === user.id
  );

  // const unseenConversations = usersConversations.filter(
  //   (x) =>
  //     (x.senderId === user.id && x.viewedBySender === false) ||
  //     (x.recipientId === user.id && x.viewedByRecipient === false)
  // );

  // console.log(unseenConversations);

  return (
    <>
      <section id="header" className="w-screen">
        <Header />
      </section>
      {modal.messages && <MessagesModal />}
      <section id="messages" className="mt-20">
        <NavigateBack />
        <div className="flex justify-center text-xl mt-5">Messages</div>
        <ul className="mt-5">
          {/* Add Logic for no messages */}
          {usersConversations.length !== 0 ? (
            usersConversations.map((item, index) => {
              return (
                <li
                  key={item.id}
                  className="px-5"
                  onClick={() => {
                    handleModal("messages");
                    setConversationId(item.id);
                    setMessageRecipientId(
                      item.recipientId === user.id
                        ? item.senderId
                        : item.recipientId
                    );
                  }}
                >
                  <div
                    className={`relative border-gray-300 py-2 pl-2
                    ${index === 0 ? "border-y-1" : "border-b-1"}`}
                  >
                    {item.senderId === user.id && !item.viewedBySender && (
                      <div name="unseen" className="absolute top-6 -left-3">
                        <GoDotFill className="text-snappily-orange" />
                      </div>
                    )}
                    {item.recipientId === user.id &&
                      !item.viewedByRecipient && (
                        <div name="unseen" className="absolute top-6 -left-3">
                          <GoDotFill className="text-snappily-orange" />
                        </div>
                      )}
                    <div className="flex justify-between capitalize">
                      <div>
                        {item.recipientId === user.id
                          ? item.sendersName
                          : item.recipientsName}
                      </div>
                      <div className="flex items-center gap-x-1">
                        <div>
                          {DateTime.fromISO(
                            item.timeOfLastMessage
                          ).toRelativeCalendar() === "today"
                            ? DateTime.fromISO(item.timeOfLastMessage).toFormat(
                                "t"
                              )
                            : DateTime.fromISO(
                                item.timeOfLastMessage
                              ).toRelativeCalendar()}
                        </div>
                        <FaChevronRight />
                      </div>
                    </div>
                    <div className="italic text-gray-400">
                      {item.lastMessage ? item.lastMessage : "No message"}...
                    </div>
                  </div>
                </li>
              );
            })
          ) : (
            <div className="flex justify-center text-slate-400">
              You current have no messages
            </div>
          )}
        </ul>
      </section>
    </>
  );
};

export default Messages;
